// @ts-check

const backends = {
  stage: { protocol: 'https:', domain: 'twisto.live', port: '' },
  dev: { protocol: 'https:', domain: 'twisto.wtf', port: '' },
  // tripping-avenger in docker compose, served by its nginx on port 8000.
  local: { protocol: 'http:', domain: 'twisto.top', port: ':8000' },
}

/**
 * Fixed destinations shared by the launcher and the browser configuration.
 * @param {string | undefined} backend
 * @param {string | undefined} region
 * @param {string} [port]
 * @returns {{ backend: 'stage' | 'dev' | 'local', region: 'CZ' | 'PL', apiOrigin: string, websiteOrigin: string, proxyOrigin: string, apiProxyOrigin: string, proxyPort: number }}
 */
const getRemoteBackend = (backend, region, port = '4000') => {
  if (backend !== 'stage' && backend !== 'dev' && backend !== 'local') {
    throw new Error('Backend must be stage, dev or local.')
  }
  if (region !== 'CZ' && region !== 'PL') {
    throw new Error('Region must be CZ or PL.')
  }
  if (!/^\d+$/.test(port) || Number(port) < 1 || Number(port) > 65535) {
    throw new Error('Proxy port must be between 1 and 65535.')
  }

  const { protocol, domain: baseDomain, port: backendPort } = backends[backend]
  const domain = `${region.toLowerCase()}.${baseDomain}${backendPort}`
  const proxyPort = Number(port)
  const proxyOrigin = new URL(`http://localhost:${proxyPort}`).origin

  return {
    backend,
    region,
    apiOrigin: `${protocol}//api.${domain}`,
    websiteOrigin: `${protocol}//www.${domain}`,
    proxyOrigin,
    apiProxyOrigin: `${proxyOrigin}/api`,
    proxyPort,
  }
}

exports.getRemoteBackend = getRemoteBackend

// Next replaces these explicit public references in the browser bundle.
// A production build must never pick up a developer's local proxy settings.
exports.remoteBackend =
  process.env.NODE_ENV === 'development' &&
  process.env.NEXT_PUBLIC_REMOTE_BACKEND
    ? getRemoteBackend(
        process.env.NEXT_PUBLIC_REMOTE_BACKEND,
        process.env.NEXT_PUBLIC_REMOTE_REGION,
        process.env.NEXT_PUBLIC_REMOTE_PROXY_PORT
      )
    : undefined
